import { useState, useEffect } from "react";
import { getAllServicesGroup } from "../../api/servicesGroupApi";
import {
  getServicesPerBarber,
  addBarberService,
  removeBarberService,
  editBarberService,
} from "../../api/barberServiceApi";
import { getAllbarbers } from "../../api/barberApi";
import { useAuth } from "../../context/AuthContext";
import EditIcon from "../../assets/icons/edit-icon.png";
import plusIcon from "../../assets/icons/plus-icon-colored.png";
import DeleteIcon from "../../assets/icons/delete-icon.png";
const useBarberService = () => {
  const { user } = useAuth();

  const [serviceGroup, setServiceGroup] = useState([]);
  const [seletedServiceGroup, setSelectedServiceGroup] = useState(null);
  const [barberList, setBarberList] = useState([]);
  const [seletedBarber, setSeletedBarber] = useState(null);
  const [services, setServices] = useState([]);
  const [assignedServices, setAssignedServices] = useState([]);
  const [notAssignedServices, setNotAssignedServices] = useState([]);

  const [editService, setEditService] = useState(null);
  const [addService, setAddService] = useState(null);
  const [deleteService, setDeleteService] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const columns1 = [
    { header: "Service Name", accessor: "name" },

    { header: "Description", accessor: "description" },
    {
      header: "Actions",
      render: (row, { onEdit }) => (
        <>
          <button className="btn btn-edit" onClick={() => onEdit(row)}>
            <img src={plusIcon} />
          </button>
        </>
      ),
    },
  ];
  const columns2 = [
    { header: "Service Name", accessor: "name" },

    { header: "Description", accessor: "description" },
    { header: "Time", accessor: "time" },
    {
      header: "Actions",
      render: (row, { onEdit, onDelete }) => (
        <>
          <button className="btn btn-edit " onClick={() => onEdit(row)}>
            <img src={EditIcon} />
          </button>
          <button className="btn btn-delete" onClick={() => onDelete(row)}>
            <img src={DeleteIcon} />
          </button>
        </>
      ),
    },
  ];
  useEffect(() => {
    fetchServiceGroups();
    fetchBarbers();
  }, []);

  const fetchServiceGroups = async () => {
    const response = await getAllServicesGroup(user.barberShop);
    var serviceGroupList = response.map((s) => ({ id: s.id, name: s.name }));
    setServiceGroup(serviceGroupList);
    setSelectedServiceGroup(serviceGroupList[0]);
  };
  const fetchBarbers = async () => {
    const response = await getAllbarbers(user.barberShop);
    var barbers = response.map((b) => ({
      id: b.id,
      name: b.firstName + " " + b.lastName,
    }));
    setBarberList(barbers);
    setSeletedBarber(barbers[0]);
  };
  useEffect(() => {
    if (seletedBarber != null && seletedServiceGroup != null)
      getRelatedServices();
  }, [seletedBarber, seletedServiceGroup]);

  const getRelatedServices = async () => {
    const response = await getServicesPerBarber(
      seletedBarber.id,
      seletedServiceGroup.id,
      user.barberShop,
    );
    let notAssignedService = response.filter((s) => s.time == 0);
    let assignedServices = response.filter((s) => s.time != 0);
    setNotAssignedServices(notAssignedService);
    setAssignedServices(assignedServices);
    setServices(response);
  };
  const onEditClick = (s) => {
    setEditService(s);
    setShowEditModal(true);
  };
  const handleEditDuration = (e) => {
    setEditService({
      ...editService,
      time: e.target.value,
    });
  };
  const onAddServiceClick = (s) => {
    setAddService(s);
    setShowAddModal(true);
  };
  const onEditServiceClick = (s) => {};
  const onServiceModalClose = () => {
    setAddService(null);
    setShowAddModal(false);
    setEditService(null);
    setShowEditModal(false);
  };
  const handelAddServiceToBarber = async (time) => {
    var response = await addBarberService(
      seletedBarber.id,
      addService.id,
      time,
      user.barberShop,
    );
    if (response.data.isSuccess) {
      getRelatedServices();
      setAddService(null);
      setShowAddModal(false);
      setMessage({ text: response.data.value, type: "success" });
      setShowMessage(true);
    } else {
      setMessage({
        text: response?.data.errors?.join("\n"),
        type: "danger",
      });
      setShowMessage(true);
    }
  };
  const handleDeleteService = async (service) => {
    setShowDeleteModal(true);
    setDeleteService(service);
  };
  const handleConfirmDelete = async () => {
    setShowDeleteModal(false);

    var response = await removeBarberService(
      seletedBarber.id,
      deleteService.id,
      user.barberShop,
    );
    if (response.isSuccess) {
      getRelatedServices();

      setDeleteService(null);
      setMessage({ text: response.value, type: "success" });
      setShowMessage(true);
    } else {
      setMessage({
        text: response?.errors?.join("\n"),
        type: "danger",
      });
      setDeleteService(null);
    }
  };
  const onCloseDeleteModal = () => {
    setDeleteService(null);
    setShowDeleteModal(false);
  };
  const handleEditService = async (time) => {
    var response = await editBarberService(
      seletedBarber.id,
      editService.id,
      time,
      user.barberShop,
    );
    if (response.data.isSuccess) {
      setEditService(null);
      setEditService(null);
      setShowEditModal(false);
      getRelatedServices();
      setMessage({ text: response.data.value, type: "success" });
      setShowMessage(true);
    } else {
      setMessage({
        text: response?.errors?.join("\n"),
        type: "danger",
      });
      setEditService(null);
    }
  };

  return {
    serviceGroup,
    seletedServiceGroup,
    setSelectedServiceGroup,
    barberList,
    seletedBarber,
    setSeletedBarber,
    notAssignedServices,
    assignedServices,
    services,
    editService,
    handleEditDuration,
    onEditClick,
    showAddModal,
    onAddServiceClick,
    addService,
    handelAddServiceToBarber,
    onServiceModalClose,
    showMessage,
    setShowMessage,
    message,
    handleDeleteService,
    handleConfirmDelete,
    onCloseDeleteModal,
    showDeleteModal,
    handleEditService,
    showEditModal,
    columns1,
    columns2,
  };
};
export default useBarberService;
